import { IAuthPayload as BaseAuth } from '@kattana-io/common';

interface IAuthPayload extends BaseAuth {
  sessionId: number;
}

const authKey = (network: string, wallet: string) => {
  return `kattana.auth_${network}_${wallet}`;
};

const isExpired = (auth: IAuthPayload): boolean => {
  const expiration = Number(auth.payload.expired_at);
  const now = Math.floor(new Date().getTime() / 1000);

  if (expiration > now) {
    return false;
  }

  return true;
};

const setAuthToLS = (auth: IAuthPayload) => {
  const key = authKey(auth.payload.network, auth.payload.wallet);
  localStorage.setItem(key, JSON.stringify(auth));
};

const getAuthFromLS = (
  network: string,
  wallet: string
): IAuthPayload | null => {
  const key = authKey(network, wallet);
  const auth = localStorage.getItem(key);
  if (auth) {
    const authObj = JSON.parse(auth);
    const expired = isExpired(authObj);

    if (expired) {
      localStorage.removeItem(key);
      return null;
    }

    return authObj;
  }

  return null;
};

export { getAuthFromLS, setAuthToLS };
